// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p206 рядок Data Layout без оформлення рівня — білий фон у розкритого рядка об'єкта, опція)
// Раскрытая строка-группа дерева REPORT2 получает класс уровня group-row-level-N (AttrGrid formatItem: фон — filter: brightness(88 / 94 / 98 %),
// жирность); у свёрнутой его нет — белый фон. Строка «без оформления уровня» получает рядом класс PLAIN_LEVEL_CLASS: CSS снимает фон уровня,
// строка выглядит как свёрнутая (жирность названия и стрелка раскрытия — как были);
// серый фон пустой строки (cell-empty, строка без итогов пуста по построению) у неё тоже снят — белый фон. Признак строки — _DLRow.plain_level (колонка «Plain level»
// строки Data Layout, бэк data_layout2._plain_level_pass); опция отчёта doc.params.plain_top_groups («Plain top group rows») — то же для всех
// строк-групп верхнего уровня без итогов (values_placement none). Выключатель fe.ux.plainLevelRows (по умолчанию вкл) — прежнее оформление.
export const PLAIN_LEVEL_CLASS = 'row-plain-level'

export function plainLevel_is(dataItem, level, { on = true, topGroups = false } = {}) {
    if (!on || !dataItem || typeof dataItem !== 'object') return false
    const dl = dataItem._DLRow
    if (!dl || typeof dl !== 'object') return false
    if (dl.plain_level === true) return true
    return !!topGroups && (Number(level) || 0) === 0 && dl.values_placement === 'none'
}
